import { authenticatedKickClient } from "~/emr/utils/kickgqlClient";
import { supportedUSStates } from "~/shared/utils/sharedUtils";

let originalCityInput = "";

function createGetScriptsurePharmacies(
  setAutocompleteValue,
  setAutocompleteErrorMsg,
  setPharmacySearchResults,
  setLoadingSearchResults,
  onError
) {
  return function (searchParams) {
    const client = authenticatedKickClient();

    setLoadingSearchResults(true);
    setAutocompleteErrorMsg("");

    return client
      .get(`/scriptsure-pharmacies?`, {
        params: searchParams,
      })
      .then(({ data }) => {
        setPharmacySearchResults(data);
        setLoadingSearchResults(false);
        setAutocompleteValue("");
        return { data };
      })
      .catch((error) => {
        console.error("Error fetching scriptsure pharmacies: ", error);
        if (typeof onError === "function") {
          onError({
            ...searchParams,
            pharmacyCity: originalCityInput,
          });
        } else {
          setAutocompleteErrorMsg(
            "Sorry, there was an error fetching pharmacy data. Please try again."
          );
          setLoadingSearchResults(false);
        }
      });
  };
}

export function onPlaceSelected(
  { name, address_components, formatted_phone_number },
  setAutocompleteValue,
  setAutocompleteErrorMsg,
  setPharmacySearchResults,
  setLoadingSearchResults,
  onError
) {
  if (!address_components) return;
  const resultObj = {};
  let longStateName = "";
  address_components.forEach(({ long_name, short_name, types }) => {
    const longNameAttrs = ["locality"];
    let useLongName = false;
    types.forEach((type) => {
      if (longNameAttrs.includes(type)) {
        useLongName = true;
      }
      if (type === "administrative_area_level_1") {
        longStateName = long_name;
      }
    });
    resultObj[types[0]] = useLongName ? long_name : short_name;
  });
  if (!supportedUSStates.includes(resultObj.administrative_area_level_1)) {
    setAutocompleteErrorMsg(
      `Sorry we're not available in ${longStateName} yet. Please choose a pharmacy in a different state.`
    );
    setAutocompleteValue("");
    return;
  }
  const searchParams = {
    pharmacyName: name,
    pharmacyAddress1: `${resultObj.street_number || ""} ${
      resultObj.route
    }`.trim(),
    pharmacyAddress2: resultObj.subpremise || "",
    pharmacyState: resultObj.administrative_area_level_1,
    pharmacyZip: resultObj.postal_code,
    pharmacyPhone: formatted_phone_number,
    pharmacyStreetNumber: resultObj.street_number || "",
  };

  searchParams.pharmacyCity =
    resultObj.locality ||
    resultObj.sublocality_level_1 ||
    resultObj.administrative_area_level_3;

  for (let key in searchParams) {
    if ([undefined, "undefined"].includes(searchParams[key])) {
      searchParams[key] = "";
    }
  }

  // if pharmacyCity is empty, delete it. Seems to make a difference in the scriptsure search results.
  if (!searchParams.pharmacyCity) {
    delete searchParams.pharmacyCity;
  }

  const getScriptsurePharmacies = createGetScriptsurePharmacies(
    setAutocompleteValue,
    setAutocompleteErrorMsg,
    setPharmacySearchResults,
    setLoadingSearchResults,
    onError
  );

  getScriptsurePharmacies(searchParams).then((result) => {
    let data = result?.data || [];

    const streetNum = searchParams.pharmacyAddress1.split(" ")[0];
    if (data.length) {
      const streetNumMatch = data.find((pharmacy) => {
        if (pharmacy.addressLine1.includes(streetNum)) {
          return true;
        }
      });
      if (streetNumMatch) {
        // if we found a match, set it as the first item
        data.splice(data.indexOf(streetNumMatch), 1);
        data = [streetNumMatch, ...data];
      }
    }

    if (!data.length && searchParams.pharmacyCity) {
      // if we didn't find anything, retry without pharmacyCity
      originalCityInput = searchParams.pharmacyCity;
      searchParams.pharmacyCity = "";
      getScriptsurePharmacies(searchParams);
    } else {
      setLoadingSearchResults(false);
      setAutocompleteValue("");
      setPharmacySearchResults(data);
    }
  });

  // set loading state
  const route = resultObj.route ? ` ${resultObj.route},` : ""; // sometimes route is empty
  let locality =
    resultObj.locality ||
    resultObj.sublocality_level_1 ||
    resultObj.administrative_area_level_3;
  if (locality) {
    locality = ` ${locality},`;
  }
  const newAutocompleteValue = `${name},${route}${locality}, ${resultObj.administrative_area_level_1}`;
  setLoadingSearchResults(true);
  setAutocompleteValue(newAutocompleteValue);
  setAutocompleteErrorMsg("");
}
